//@author: devin
import { NgModule } from "@angular/core";
import { PopoverComponent } from "./popover.component";
import { PopoverDefaultComponent } from "./popover.default.component";

@NgModule({
    imports: [PopoverComponent, PopoverDefaultComponent],
    exports: [PopoverComponent],
})
export class PopoverModule {
    constructor() {}
}
